import { useRoutes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useMemo } from "react";

import Routes from "./Routes";
import "./App.css";
import { findGetParameter, urlParams } from "./utils/urlParams";
import { getDesignTokens } from "./global/DefaultTheme";
import GlobalStyles from "./global/GlobalStyles";

function App() {
  const routing = useRoutes(Routes());

  const { client_id, redirect_uri, state } = urlParams();
  if (client_id) sessionStorage.setItem("client_id", client_id);
  if (redirect_uri) localStorage.setItem("redirect_uri", redirect_uri);
  if (state) localStorage.setItem("state", state);

  // Theme variables
  const urlTheme = findGetParameter("theme");
  const prefersDarkMode = window.matchMedia(
    "(prefers-color-scheme: dark)",
  ).matches;
  const mode =
    ((urlTheme === "dark" || urlTheme === "light") && urlTheme) ||
    sessionStorage?.getItem("themeMode") ||
    (prefersDarkMode ? "dark" : "light");
  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
    </ThemeProvider>
  );
}

export default App;
